
import API from '../../utils/Api'
import i18n from '@/plugins/i18n'
import Config from '../../config'

const companiesApi = new API('companies')
const actionsApi = new API('game-actions')

const state = {
  data: null,
  loading: false,
  forcedNextDay: false
}

const getters = {

  ddOrderPreFilled: state =>  state.data !== null ? state.data.game.params.ddOrderPreFilled : true,

  avatar: state => state.data ? state.data.avatar : 0,

  filesUrl: state => Config.filesUrl + state.data.instance + '/',

  supplyPicture: state => {
    return state.data ? state.data.companieSettings.supplyPicture : false
  },

  isProductionCompany: state => {
    return state.data ? state.data.companieSettings.productionCompany : false
  },

  companyIsLoad: state => {
    return state.data ? true : false
  },

  flowEquationDisplay: state => {
    return state.data !== null ? state.data.game.params.flowEquationDisplay : 0
  },

  ddOn: state => {
    return state.data !== null ? state.data.ddOn : false
  },

  productionCompany: state => {
    return state.data !== null ? state.data.productionCompany : false
  },
  
  companySettings: state => {
    return state.data !== null ? state.data.companieSettings : null
  },

  clients: state => {
    return state.data !== null ? state.data.clients : []
  },

  suppliers: state => {
    return state.data !== null ? state.data.suppliers : []
  },

  logo: state => {
    return state.data !== null ? state.data.companieSettings : null
  },

  name: state => {
    return state.data !== null ? state.data.name : ''
  },

  ready: state => {
    return state.data !== null ? state.data.ready : false
  },

  week: state => {
    return state.data !== null ? state.data.week : 0
  },

  productionLeadTime: state => {
    return state.data !== null ? state.data.productionLeadTime : 0
  },

  stock: state => {
    if ((state.data !== null && state.data.data.value.stock[state.data.data.value.stock.length - 1] != undefined)) {
      return state.data.data.value.stock[state.data.data.value.stock.length - 1]
    } else if (state.data) {
      return state.data.initialStock
    } else {
      return 0
    }
  },

  loading: state => {
    return state.loading
  },

  data: state => {
    return state.data !== null  ? state.data.data : null
  }

}

const actions = {
  async getOne({ commit}, id) {
    try {
      commit('SET_loading', true)
      let res = await companiesApi.get(id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async setReady({ commit, state}, avatar) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.put(state.data._id, {ready: true, avatar: avatar}, '/ready')
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async startWeek({ commit, state}) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(null, '/start-week/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async setBuffer({ commit, state}, params) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(params, '/buffer/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async setFlowEquation({ commit, state}, params) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(params, '/flow-equation/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async clientsShipments({ commit, state}, params) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(params, '/clients-shipments/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async suppliersOrders({ commit, state}, params) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(params, '/suppliers-orders/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async productionBatch({ commit, state}, params) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(params, '/production-batch/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async productionReceipts({ commit, state}) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(null, '/production-company-receipts/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async suppliersReceipts({ commit, state}) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.post(null, '/suppliers-receipts/' + state.data._id)
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  async setStep({ commit, state}, step) {
    try {
      commit('SET_loading', true)
      let res = await actionsApi.put(state.data._id, {step: step}, '/step')
      commit('SET_company', res.data)
      commit('SET_loading', false)
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('store.error') + error.message }, { root: true })
    }
  },

  SOCKET_playerNextDay ({commit}, val) {
    commit('SET_forcedNextDay', val.company)
  },
  
  
  SOCKET_shipments ({commit, state}, val) {
    if (val.company._id.toString() === state.data._id.toString()) {
      commit('SET_company', val.company)
    }
  }
}

const mutations = {
  SET_company(state, val) {
    state.data = val
  },
  SET_loading(state, val) {
    state.loading = val
  },
  SET_forcedNextDay(state, val) {
    if (state.data._id.toString() == val && state.loading == false) {
      state.forcedNextDay = true
    }
  },
  UNSET_forcedNextDay(state) {
    state.forcedNextDay = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}